import {SubscriptionLike} from "rxjs";
import {DestroyRef} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";

const debug = initDebugger('LukkAbonnementer');

/** Register for åpne abonnementer ({@link SubscriptionLike}) som gjør det enkelt å avslutte disse
 * i en operasjon - via kall til {@link #avsluttAlle}.
 *
 * <pre>
 * Eksempel på bruk i komponent:
 *
 * class EnKomp implements OnDestroy {
 *   private ab = new LukkAbonnementer();
 *
 *   enMetode() { this.ab.reg( enSubscribable.subscribe(...) ); }
 *
 *   //VIKTG:
 *   ngOnDestroy(): void { this.ab.avsluttAlle(); }
 * }
 * </pre>
 *
 * MERK
 * Bruk heller `takeUntilDestroyed` i `@angular/core/rxjs-interop`,
 * som vil passe på å destroye subscription når komponent destroyes.
 * <pre>
 * import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
 * @Component({...})
 * export default class HomeComponent {
 *   constructor() {
 *     interval(1000).pipe(takeUntilDestroyed()).subscribe(console.log);
 *   }
 * }
 * </pre>
 */
export class LukkAbonnementer {
    private abonnementer: SubscriptionLike[] = []

    reg<T extends SubscriptionLike>(abonnement: T) {
        this.abonnementer.push(abonnement);
        return abonnement;
    }

    avsluttAlle() {
        debug(`lukker ${this.abonnementer.length} abonnementer`);
        this.abonnementer.forEach(abonnement => abonnement.unsubscribe());
        this.abonnementer = [];
    }

    registrerHosDestroyRef(destroyRef: DestroyRef) {
        destroyRef.onDestroy(() => this.avsluttAlle());
    }
}
